import { combineReducers } from 'redux';
import {
    INITIAL_STATE,
    EOD_GET_LOADING, EOD_GET_SUCCESS, EOD_GET_ERROR,
    EOD_SAVE_LOADING, EOD_SAVE_SUCCESS, EOD_SAVE_ERROR,
    EOD_UPDATE_LOADING, EOD_UPDATE_SUCCESS, EOD_UPDATE_ERROR,
    EOD_DELETE_LOADING, EOD_DELETE_SUCCESS, EOD_DELETE_ERROR,
    EOD_LIST_LOADING, EOD_LIST_SUCCESS, EOD_LIST_ERROR,
    EOD_VIEW_LOADING, EOD_VIEW_SUCCESS, EOD_VIEW_ERROR,
    EOD_MASTER_LOADING, EOD_MASTER_SUCCESS, EOD_MASTER_ERROR,
    EOD_PAYMENT_LOADING, EOD_PAYMENT_SUCCESS, EOD_PAYMENT_ERROR

} from './actions';

const eodGet = (state = INITIAL_STATE, actions) => {
    switch (actions.type) {
        case EOD_GET_LOADING:
            return {
                ...state,
                status: 'loading',
                loading: actions.loading,
                data: actions.data,
                error: actions.error
            }
        case EOD_GET_SUCCESS:
            return {
                ...state,
                status: 'success',
                loading: actions.loading,
                data: actions.data,
                error: actions.error
            }
        case EOD_GET_ERROR:
            return {
                ...state,
                status: 'error',
                loading: actions.loading,
                data: actions.data,
                error: actions.error

            }
        default:
            return INITIAL_STATE
    }
}

const eodSave = (state = INITIAL_STATE, actions) => {
    switch (actions.type) {
        case EOD_SAVE_LOADING:
            return {
                ...state,
                status: 'loading',
                loading: actions.loading,
                data: actions.data,
                error: actions.error
            }
        case EOD_SAVE_SUCCESS:
            return {
                ...state,
                status: 'success',
                loading: actions.loading,
                data: actions.data,
                error: actions.error
            }
        case EOD_SAVE_ERROR:
            return {
                ...state,
                status: 'error',
                loading: actions.loading,
                data: actions.data,
                error: actions.error

            }
        default:
            return INITIAL_STATE
    }
}

const eodUpdate = (state = INITIAL_STATE, actions) => {
    switch (actions.type) {
        case EOD_UPDATE_LOADING:
            return {
                ...state,
                status: 'loading',
                loading: actions.loading,
                data: actions.data,
                error: actions.error
            }
        case EOD_UPDATE_SUCCESS:
            return {
                ...state,
                status: 'success',
                loading: actions.loading,
                data: actions.data,
                error: actions.error
            }
        case EOD_UPDATE_ERROR:
            return {
                ...state,
                status: 'error',
                loading: actions.loading,
                data: actions.data,
                error: actions.error

            }
        default:
            return INITIAL_STATE
    }
}

const eodDelete = (state = INITIAL_STATE, actions) => {
    switch (actions.type) {
        case EOD_DELETE_LOADING:
            return {
                ...state,
                status: 'loading',
                loading: actions.loading,
                data: actions.data,
                error: actions.error
            }
        case EOD_DELETE_SUCCESS:
            return {
                ...state,
                status: 'success',
                loading: actions.loading,
                data: actions.data,
                error: actions.error
            }
        case EOD_DELETE_ERROR:
            return {
                ...state,
                status: 'error',
                loading: actions.loading,
                data: actions.data,
                error: actions.error

            }
        default:
            return INITIAL_STATE
    }
}

const eodList = (state = INITIAL_STATE, actions) => {
    switch (actions.type) {
        case EOD_LIST_LOADING:
            return {
                ...state,
                status: 'loading',
                loading: actions.loading,
                data: actions.data,
                error: actions.error
            }
        case EOD_LIST_SUCCESS:
            return {
                ...state,
                status: 'success',
                loading: actions.loading,
                data: actions.data,
                error: actions.error
            }
        case EOD_LIST_ERROR:
            return {
                ...state,
                status: 'error',
                loading: actions.loading,
                data: actions.data,
                error: actions.error

            }
        default:
            return INITIAL_STATE
    }
}

const eodView = (state = INITIAL_STATE, actions) => {
    switch (actions.type) {
        case EOD_VIEW_LOADING:
            return {
                ...state,
                status: 'loading',
                loading: actions.loading,
                data: actions.data,
                error: actions.error
            }
        case EOD_VIEW_SUCCESS:
            return {
                ...state,
                status: 'success',
                loading: actions.loading,
                data: actions.data,
                error: actions.error
            }
        case EOD_VIEW_ERROR:
            return {
                ...state,
                status: 'error',
                loading: actions.loading,
                data: actions.data,
                error: actions.error

            }
        default:
            return INITIAL_STATE
    }
}

const eodMaster = (state = INITIAL_STATE, actions) => {
    switch (actions.type) {
        case EOD_MASTER_LOADING:
            return {
                ...state,
                status: 'loading',
                loading: actions.loading,
                data: [],
                error: false
            }
        case EOD_MASTER_SUCCESS:
            return {
                ...state,
                status: 'success',
                loading: false,
                data: actions.data,
                error: false
            }
        case EOD_MASTER_ERROR:
            return {
                ...state,
                status: 'error',
                loading: false,
                data: [],
                error: true

            }
        default:
            return state
    }
}

const eodPayment = (state = INITIAL_STATE, actions) => {
    switch (actions.type) {
        case EOD_PAYMENT_LOADING:
            return {
                ...state,
                status: 'loading',
                loading: actions.loading,
                data: [],
                error: false
            }
        case EOD_PAYMENT_SUCCESS:
            return {
                ...state,
                status: 'success',
                loading: false,
                data: actions.data,
                error: false
            }
        case EOD_PAYMENT_ERROR:
            return {
                ...state,
                status: 'error',
                loading: false,
                data: [],
                error: actions.error

            }
        default:
            return state
    }
}


const eodReducer = combineReducers({
    data: eodGet,
    save: eodSave,
    update: eodUpdate,
    delete: eodDelete,
    list: eodList,
    view: eodView,
    master: eodMaster,
    payment: eodPayment
})

export default eodReducer;